export function mapInvitation(invitationData) {
  return {
    id: invitationData.id,
    recipientFirstname: invitationData.recipientFirstname || null,
    recipientLastname: invitationData.recipientLastname || null,
    recipientEmail: invitationData.recipientEmail || null,
    isAccepted: invitationData.isAccepted || null,
    expiresAt: invitationData.expiresAt || null,
    createdAt: invitationData.createdAt || null
  }
}
